import { useCallback } from 'react';

import { FormInputProps } from '@occc-app/design-system';
import { LazyAutocompleteField, StacksIcon } from '@occc/ui-design-system';
import { Offer_Engagement_Type, OfferFilter, OfferSelectItemFragment } from '@occc/graphql';
import { useChainId } from '@occc-app/Chain/hooks';
import { useGetOfferSelectListLazy } from '@occc-app/dataAccessLayer/offer/queries';

type LocationGroupMultipleSelectProps = {
  name: string;
  inputProps?: FormInputProps;
  label?: string;
};

const mapQueryResponseToRawArray = (
  response: ReturnType<typeof useGetOfferSelectListLazy>['response'],
) => response.data || [];

const mapRawResponseItemToAutocompleteOption = (offer: OfferSelectItemFragment) => ({
  label: offer.name,
  value: offer.id,
  _raw: offer,
});

export const AwardMultipleSelect = ({
  name,
  inputProps,
  label,
}: LocationGroupMultipleSelectProps) => {
  const chainId = useChainId();
  const makeQueryFilter = useCallback(
    (search: string): OfferFilter => ({
      search: search || null,
      chainIdEquals: chainId,
      deleted: false,
      engagementTypeIncludes: [
        Offer_Engagement_Type.Vouchered,
        Offer_Engagement_Type.FuelRollback,
        Offer_Engagement_Type.SweepstakesEntry,
        Offer_Engagement_Type.GameVoucher,
      ],
    }),
    [chainId],
  );

  return (
    <LazyAutocompleteField
      name={name}
      label={label ?? 'Select Awards'}
      inputProps={inputProps}
      useLazyQuery={useGetOfferSelectListLazy}
      makeQueryFilter={makeQueryFilter}
      mapQueryResponseToRawArray={mapQueryResponseToRawArray}
      mapRawResponseItemToAutocompleteOption={mapRawResponseItemToAutocompleteOption}
      chipPropsIcon={StacksIcon}
    />
  );
};
